module.exports = __webpack_public_path__ + "img/5-find.909a8dc7.svg";